import {
    createTheme,
  } from "@mui/material";
  
  const themePalette = {
    primary: {
      main: "#FFFFFF",
    },
    background: {
      default: "#FFFFFF",
    },
  };
  
  const theme = createTheme({
    palette: themePalette,
    typography: {
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 700,
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            border: "none",
          },
          root: {
            border: '1px solid black'
          },
        },
      },
    },
  });
  
  // 12px
  theme.typography.body2 = {
    fontSize: "0.75rem",
  };
  
  // 14px
  theme.typography.body1 = {
    fontSize: "0.875rem",
  };
  
  theme.typography.subtitle2 = {
    fontSize: "0.75rem",
    fontWeight: "bold",
  };
  
  theme.typography.subtitle1 = {
    fontSize: "0.875rem",
    fontWeight: "bold",
  };
  // 16px
  theme.typography.h6 = {
    fontSize: "1rem",
  };
  
  // 19px
  theme.typography.h5 = {
    fontSize: "1.188rem",
  };
  
  // 27px
  theme.typography.h4 = {
    fontSize: "1.688rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1rem",
    },
    [theme.breakpoints.only("sm")]: {
      fontSize: "1.3rem",
    },
  };
  
  // 31px
  theme.typography.h3 = {
    fontSize: "1.938rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    },
  };
  
  export { theme };
  